import React from "react";
import Dropzone from "react-dropzone";
import { CloudUploadOutlined } from "@mui/icons-material";
import { DropContainer, UploadMessage, Container, Content } from "./styles";

export default function FileDropzone({ onUpload }) {
  const dragMessage = (isDragActive, isDragReject) => {
    if (!isDragActive) {
      return (
        <UploadMessage>
          <CloudUploadOutlined
            style={{ width: "25px", height: "25px", color: "#f00" }}
          />
          Arraste os arquivos aqui
        </UploadMessage>
      );
    }
    if (isDragReject) {
      return <UploadMessage type="error">Arquivo não suportado</UploadMessage>;
    }
    return <UploadMessage type="success">Solte os arquivos aqui</UploadMessage>;
  };

  return (
    <Container>
      <Content>
        <Dropzone
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onDropAccepted={onUpload}
        >
          {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
            <DropContainer
              {...getRootProps()}
              isDragActive={isDragActive}
              isDragReject={isDragReject}
            >
              <input {...getInputProps()} />
              {dragMessage(isDragActive, isDragReject)}
            </DropContainer>
          )}
        </Dropzone>
      </Content>
    </Container>
  );
}
